import { Component, ElementRef, EventEmitter, Input, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FiltersM } from '../models';
import { FilterEngineService } from './engine/filter-engine.service';
import { display } from 'html2canvas/dist/types/css/property-descriptors/display';
import { FilterDisplay, FilterDisplayConfig } from './models/filter-display.enum';

@Component({
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrl: './filters.component.css'
})
export class FiltersComponent {
  public Filters = FiltersM;
  public dataFilter = [];

  visibleChips: any[] = [];
  hiddenCount = 0;
  @ViewChild('chipsViewport', { static: false }) viewport?: ElementRef<HTMLDivElement>;
  @ViewChildren('chipItem') chipItems!: QueryList<ElementRef<HTMLDivElement>>;
  selectedChip = [];

  @Input() name: string;
  @Input() icono: string;
  @Input() typeFilter: FiltersM;
  @Input() array: any[];
  @Input() original: any [];
  @Input() click: boolean = true;
  @Input() sucursales: any[];
  //Variables del filtro de sucursales
  @Input() consolidado: boolean = false;
  @Input() busqueda: boolean = false;
  @Input() textoConsolidado: string = 'Consolidado';
  @Input() configuracion: FilterDisplayConfig = {
    mode: FilterDisplay.AUTO,
    maxLabels: 1,
    placeholder: ''
  };
  /** Ensancha el panel del desplegable (misma clase que sucursales) sin afectar otros usos */
  @Input() panelAncho: boolean = false;

  @Output() eventClick = new EventEmitter;
  
  filter;
  constructor(
    private readonly filterEngine: FilterEngineService
  ){}

  public selectInformation(elemnt, chip?){
    if(chip && !this.click){
      return ;
    }
    this.eventClick.emit(elemnt);
  }
  
  ngOnChanges() {
    this.filter = this.filterEngine.build({
      id: 'periodo',
      title: this.name,
      filter: this.typeFilter,
      data: this.array,
      display: this.configuracion,
      consolidado: this.consolidado,
      textoConsolidado: this.textoConsolidado,
      searchable: this.busqueda,
    });

    //TODO: ELiminar este codigo no funciona para nada al implementar los nuevos filtros
    if (this.typeFilter !== FiltersM.PERIOD) return;

    setTimeout(() => {
      this.selectedChip = this.array
        ?.flatMap(anio => anio.series ?? [])
        .filter(mes => mes.check);

      this.calculateVisibleChips(this.selectedChip);
    });
  }

  //TODO: Decrepeted No funciona para nada ya este codigo al implementar los nuevos filtros
  calculateVisibleChips(allChips: any[]) {
    if(!this.viewport) return;
    requestAnimationFrame(() => {
      const viewportWidth = this.viewport.nativeElement.offsetWidth;
      let usedWidth = 0;

      this.visibleChips = [];
      this.hiddenCount = 0;

      for (let chip of allChips) {
        const temp = document.createElement('div');
        temp.className = 'filtroChipSelect';
        temp.style.position = 'absolute';
        temp.style.visibility = 'hidden';
        temp.innerText = chip.label;

        document.body.appendChild(temp);
        const chipWidth = temp.offsetWidth + 6; // gap
        document.body.removeChild(temp);

        if (usedWidth + chipWidth <= viewportWidth) {
          usedWidth += chipWidth;
          this.visibleChips.push(chip);
        } else {
          this.hiddenCount++;
        }
      }
    });
  }
  ngAfterViewInit() {
    if(!this.viewport) return;
    const resizeObserver = new ResizeObserver(() => {
      this.selectedChip = this.array.flatMap(anio => anio.series).filter(mes => mes.check);
      this.calculateVisibleChips(this.selectedChip);
    });

    resizeObserver.observe(this.viewport.nativeElement);
  }
  public filterOpt(event: any){
    const valor = event.target.value.toLowerCase();
    this.array = this.original.filter(d =>
      (d.name || '')
        .toLowerCase()
        .includes(valor)
    );
  }
}
